// removed by extract-text-webpack-plugin
module.exports = {"component":"_2Mmq1yHv8s2naTfbrLigk0","modalTitle":"TwjcbZ2r6cVgONam_RX1Y","modalContent":"_2_K2C0QjS8_eVtAwhKjaHn","label":"_1oxGa0RA8hG3_UUfxOz0a6","input":"_1dyfG3mddXm-a8xG8XFXBY","zhuan_a":"_3UVjio1-pE9DQhsQ-eBiPz","zhuan":"k-6_V03848vAZyYDsxxM8"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ChangeInfoModal/ChangeInfoModal.scss
 ** module id = 955
 ** module chunks = 0
 **/